import React, { useState, useEffect, useContext } from 'react';
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  useScrollTrigger,
  Divider
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import Close from '@mui/icons-material/Close';
import personFill from '@iconify/icons-eva/person-fill';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import SubjectIcon from '@mui/icons-material/Subject';
import { NavLink, useLocation, useNavigate, Link } from 'react-router-dom';
import { AddBox } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import secureLocalStorage from 'react-secure-storage';
import i18next from 'i18next';
import { menuNavbar } from '../../../DATA/DataText';
import AuthContext from '../../../context/AuthContext';
import AccountPopover from '../../../layouts/dashboard/AccountPopover';

const useStyles = makeStyles((theme) => ({
  Toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 7%',
    backgroundColor: 'red'
  },
  logoNav: {
    width: 130,
    height: 50,
    objectFit: 'contain'
  },
  List: {
    display: 'flex',
    listStyle: 'none',
    alignItems: 'center',
    '@media (max-width:1200px)': {
      display: 'none'
    }
  },
  ListMobile: {
    display: 'none',
    listStyle: 'none',
    '@media (max-width:1200px)': {
      position: 'absolute',
      display: 'block',
      backgroundColor: '#fff',
      color: 'lightgrey',
      right: '0px',
      top: '80px',
      transition: 'all 0.5s ease-out',
      width: '100%',
      textAlign: 'left',
      boxShadow: '0 10px 25px 0 rgb(1 45 126 / 5%)',
      paddingBottom: 20
    }
  },
  itemMobile: {
    borderTop: '1px solid lightgray'
  },
  Links: {
    fontSize: '1rem',
    fontFamily: 'Oregano, cursive',
    fontWeight: 500,
    transition: 'all 0.3s ease-out',
    cursor: 'pointer',
    textDecoration: 'none',
    margin: 15,
    textTransform: 'capitalize',
    color: 'grey',
    zIndex: 2,
    '&:hover': {
      color: '#F78181'
    }
  },
  LinksLogin: {
    fontSize: '14px',
    fontFamily: 'Oregano, cursive',
    fontWeight: 600,
    transition: 'all 0.3s ease-out',
    cursor: 'pointer',
    textDecoration: 'none',
    letterSpacing: '.05em',
    margin: 15,
    textTransform: 'uppercase',
    color: '#F78181',
    zIndex: 2,
    '&:hover': {
      color: 'white'
    }
  },
  LinkBlack: {
    color: 'black'
  },
  LinkWhite: {
    color: 'white'
  },
  loginButton: {
    border: '2px solid #F78181',
    borderRadius: 25,
    transition: 'all 0.3s ease-out',
    cursor: 'pointer',
    backgroundColor: 'white',
    zIndex: 1,
    fontSize: '14px',
    fontFamily: 'Oregano, cursive',
    fontWeight: 600,
    textDecoration: 'none',
    letterSpacing: '.05em',
    textTransform: 'uppercase',
    color: '#F78181',
    padding: '5px 20px',
    '&:hover': {
      backgroundColor: '#F78181',
      color: 'white'
    }
  },
  dropDown: {
    display: 'none',
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    margin: '0px auto',
    backgroundColor: 'white',
    minWidth: '160px',
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.2)',
    listStyle: 'none',
    borderRadius: 10,
    zIndex: 1000,
    '@media (max-width:1200px)': {
      display: 'block',
      top: 0,
      position: 'relative',
      boxShadow: 'none',
      minWidth: '100%',
      height: 0,
      overflow: 'hidden',
      transition: 'height ease 0.9s'
    }
  },
  dropDownShow: {
    height: 80
  },
  menuDrop: {
    position: 'relative',
    display: 'block',
    cursor: 'pointer',
    textDecoration: 'none',
    padding: '5px',
    '&:hover': {
      '& $Links': {
        color: '#f78181'
      }
    }
  },
  btnDrop: {
    position: 'relative'
  },
  langButton: {
    position: 'relative',
    '&:hover': {
      '& $dropDown': {
        display: 'block'
      },
      '& $btnDrop': {
        color: '#f78181'
      }
    }
  },
  Icon: {
    color: 'black',
    '&:hover': {
      color: 'green'
    }
  },
  mobileicon: {
    display: 'none',
    '@media (max-width:1200px)': {
      display: 'block',
      color: 'black'
    }
  }
}));

const MENU_OPTIONS = [
  {
    label: 'Myaccount',
    icon: personFill,
    linkTo: '/dashboard/profile'
  },
  {
    label: 'Dashboard',
    icon: pieChart2Fill,
    linkTo: '/dashboard/actuality'
  }
];

export default function NavbarFirstPage(props) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { user, logoutUser } = useContext(AuthContext);
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const userDetails = JSON.parse(localStorage.getItem('user'));
  const pic = userDetails ? `${API_ENDPOINT}${userDetails.photo}` : null;
  const Location = useLocation();
  const [isMobile, setIsMobile] = useState(false);
  const [lang, setLang] = useState(() =>
    localStorage.getItem('lang') ? localStorage.getItem('lang') : 'Français'
  );
  const [selected, setSelected] = useState(Location.pathname);
  const [open, setOpen] = useState(false);
  const [t, i18n] = useTranslation();

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: props.window ? window() : undefined
  });

  const ButtonLogin = () => {
    if (!user) {
      return (
        <Link
          to="/login"
          className={classes.loginButton}
          style={{
            margin:
              !isMobile && (document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px')
          }}
          onClick={() => setSelected('/login')}
        >
          {t('se_connecter')}
        </Link>
      );
    }
    if (user && !isMobile) {
      return <AccountPopover menu={MENU_OPTIONS} />;
    }
    if (user && isMobile) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start'
          }}
        >
          <IconButton
            onClick={() => navigate('dashboard/profile')}
            sx={{
              padding: 0,
              width: 44,
              height: 44,
              marginBottom: '10px',
              ...(open && {
                '&:before': {
                  zIndex: 1,
                  content: "''",
                  width: '100%',
                  height: '100%',
                  borderRadius: '50%',
                  position: 'absolute'
                }
              })
            }}
          >
            <Avatar src={pic} alt={userDetails.username} />
          </IconButton>
          <Link
            to="/login"
            className={classes.loginButton}
            style={{
              margin:
                !isMobile && (document.body.dir === 'ltr' ? '0px 0px 0px 35px' : '0px 35px 0px 0px')
            }}
            onClick={() => setSelected('/login')}
          >
            {t('logout')}
          </Link>
        </div>
      );
    }
  };

  return (
    <AppBar
      elevation={0}
      position="fixed"
      style={{
        backgroundColor: 'white',
        boxShadow:
          trigger || window.location.pathname === '/login'
            ? '0 10px 25px 0 rgb(1 45 126 / 5%)'
            : undefined
      }}
    >
      <Toolbar className={classes.Toolbar} style={{ backgroundColor: 'white' }}>
        <img alt="img" src="/static/logo/logoPink.png" className={classes.logoNav} />
        <ul className={isMobile ? classes.ListMobile : classes.List}>
          {menuNavbar.map((row, key) => (
            <li className={isMobile && classes.itemMobile} style={{ padding: isMobile ? 20 : 10 }}>
              <Link
                to={row.path}
                className={classes.Links}
                style={{ color: selected === row.path && !isMobile && '#F78181' }}
                onClick={() => setSelected(row.path)}
              >
                {t(row.name)}
              </Link>
            </li>
          ))}
          <li
            className={isMobile ? classes.itemMobile : classes.langButton}
            style={{ padding: isMobile ? 20 : 10 }}
            aria-hidden="true"
            onClick={handleOpen}
          >
            <a className={`${classes.Links} ${classes.btnDrop}`}>
              {lang}
              <KeyboardArrowDown style={{ position: 'absolute', fontSize: 18, top: 0 }} />
            </a>
            {isMobile ? (
              <ul className={open ? classes.dropDownShow : classes.dropDown}>
                <li className={classes.menuDrop}>
                  <a
                    role="button"
                    aria-hidden="true"
                    className={classes.Links}
                    onClick={() => {
                      setLang('Français');
                      i18n.changeLanguage('fr');
                      document.body.setAttribute('dir', 'ltr');
                      localStorage.setItem('lang', 'Français');
                    }}
                  >
                    Français
                  </a>
                </li>
                <li className={classes.menuDrop}>
                  <a
                    role="button"
                    aria-hidden="true"
                    className={classes.Links}
                    onClick={() => {
                      setLang('العربية');
                      i18n.changeLanguage('ar');
                      document.body.setAttribute('dir', 'rtl');
                      localStorage.setItem('lang', 'العربية');
                    }}
                  >
                    العربية
                  </a>
                </li>
              </ul>
            ) : (
              <ul className={classes.dropDown}>
                <li className={classes.menuDrop}>
                  <a
                    role="button"
                    aria-hidden="true"
                    className={classes.Links}
                    onClick={() => {
                      setLang('Français');
                      i18n.changeLanguage('fr');
                      document.body.setAttribute('dir', 'ltr');
                      localStorage.setItem('lang', 'Français');
                    }}
                  >
                    Français
                  </a>
                </li>
                <Divider sx={{ my: 1 }} />
                <li className={classes.menuDrop}>
                  <a
                    role="button"
                    aria-hidden="true"
                    className={classes.Links}
                    onClick={() => {
                      setLang('العربية');
                      i18n.changeLanguage('ar');
                      document.body.setAttribute('dir', 'rtl');
                      localStorage.setItem('lang', 'العربية');
                    }}
                  >
                    العربية
                  </a>
                </li>
              </ul>
            )}
          </li>
          <li style={{ marginLeft: 20 }}>
            <ButtonLogin />
          </li>
        </ul>
        <Box
          className={classes.mobileicon}
          onClick={() => {
            setIsMobile(!isMobile);
            setOpen(false);
          }}
        >
          {isMobile ? <Close /> : <SubjectIcon />}
        </Box>
      </Toolbar>
    </AppBar>
  );
}
